import React from 'react';

// Profile entry at the top right of the header on every main screen (#49, Figma 787:16077):
// a 40px avatar with a white ring inside a 48px tap target.
export default function HeaderProfileButton({ avatarUrl, isActive, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`app-header__slot app-header__profile${isActive ? ' is-active' : ''}`}
      aria-label="Profile"
      aria-current={isActive ? 'page' : undefined}
    >
      <img src={avatarUrl} alt="" className="avatar avatar-border app-header__avatar" />
    </button>
  );
}
